import { useChannel } from "@/contexts/ChannelContext";
import Typography from "@components/Typography";

import styles from "./ChannelMetadata.module.css";

const ChannelMetadata = () => {
  const { channel: channel } = useChannel();
  const djangoAdminURL = `https://allears.ai/admin-allears/channels/channel/${channel?.id}/`;

  return (
    <div className={styles.channelMetadata}>
      <Typography variant="subtitle-2" className={styles.title}>
        Metadata
      </Typography>
      <p>
        Channel ID: <span className={styles.metadataValue}>{channel?.id}</span>
      </p>
      <p>
        Django Admin:{" "}
        <span className={styles.metadataValue}>
          <a href={djangoAdminURL}>{djangoAdminURL}</a>
        </span>
      </p>
      {channel?.external_source_url && (
        <p>
          External source URL:{" "}
          <span className={styles.metadataValue}>
            <a href={channel?.external_source_url}>
              {channel?.external_source_url}
            </a>
          </span>
        </p>
      )}
      {channel?.refresh_module && (
        <p>
          Refresh module:{" "}
          <span className={styles.metadataValue}>
            {channel?.refresh_module}
          </span>
        </p>
      )}
      {channel?.external_id && (
        <p>
          External ID:{" "}
          <span className={styles.metadataValue}>{channel.external_id}</span>
        </p>
      )}
      {channel?.refresh_frequency && (
        <p>
          Refresh frequency:{" "}
          <span className={styles.metadataValue}>
            {channel.refresh_frequency}
          </span>
        </p>
      )}
    </div>
  );
};

export default ChannelMetadata;
